<template>
  <button
    @click="toggleModal"
    class="flex items-center justify-center md:bg-transparent bg-primary md:w-32 h-[48px] md:p-1 md:px-0 px-4 text-sm border rounded-lg md:text-base md:border-[#ccc] md:text-gray-500 md:font-light"
  >
    <div class="hidden md:flex">
      <span>More Filters</span>
      <DropdownIconSvg
        color="black"
        height="4"
        width="4"
        :class="{ 'rotate-180': isDropdownOpen }"
      />
    </div>
    <div class="flex text-white md:hidden">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
        />
      </svg>
    </div>
  </button>
</template>

<script>
import { ref } from "vue";
import DropdownIconSvg from "@/components/svg/DropDownIconSvg.vue";

export default {
  name: "MoreFiltersButton",
  components: { DropdownIconSvg },
  emits: ["toggle-modal"],
  setup(_, { emit }) {
    const isDropdownOpen = ref(false);

    const toggleModal = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
      emit("toggle-modal");
    };

    return {
      isDropdownOpen,
      toggleModal,
    };
  },
};
</script>

<style scoped>
/* Button styling */
</style>
